import { eviSearch } from '~/services/serviceInstances';

export interface PositionByHandlerParam {
  handler_id: number;
  query: Array<any>;
  sort: string;
}

export const getPositionByHandler = ({
  handler_id,
  query,
  sort,
}: PositionByHandlerParam) => {
  return eviSearch.post('/position-by-handler', {
    data: {
      attributes: {
        handler_id: Number(handler_id),
        query,
        sort,
      },
    },
  });
};
